import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
var _RouteMatcher, _RouteMatcher1, _RouteMatcher2, _RouteMatcher3;
import { RouteMatcher } from "@faire/web--source/common/routes/RouteMatcher";
import { darkReadRoutes, darkReadOverrideLocaleHeaderRoutes } from "@faire/web-api--source/darkReads";
export var getAllowList = function(method) {
    return(// @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    DARK_READ_ALLOW_LIST[method]);
};
var DARK_READ_ALLOW_LIST = {
    POST: (_RouteMatcher = RouteMatcher).of.apply(_RouteMatcher, _to_consumable_array(darkReadRoutes.POST)),
    GET: (_RouteMatcher1 = RouteMatcher).of.apply(_RouteMatcher1, _to_consumable_array(darkReadRoutes.GET))
};
export var getOverrideLocaleHeaderAllowList = function(method) {
    return DARK_READ_OVERRIDE_LOCALE_HEADER_ALLOW_LIST[method];
};
var DARK_READ_OVERRIDE_LOCALE_HEADER_ALLOW_LIST = {
    POST: (_RouteMatcher2 = RouteMatcher).of.apply(_RouteMatcher2, _to_consumable_array(darkReadOverrideLocaleHeaderRoutes.POST)),
    GET: (_RouteMatcher3 = RouteMatcher).of.apply(_RouteMatcher3, _to_consumable_array(darkReadOverrideLocaleHeaderRoutes.GET))
};
